import type { FC } from 'react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, CircularProgress, Stack, Typography } from '@mui/material';

import type { ModalProps } from 'src/components/common/Modal';
import Modal from 'src/components/common/Modal';

export interface LanguageChooserModalProps extends ModalProps {
  languageChoices: { key: string; translation: string }[];
  onSelectLanguage: (lang: string) => Promise<any>;
}

const LanguageChooserModal: FC<LanguageChooserModalProps> = ({
  languageChoices,
  onSelectLanguage,
  ...modalProps
}) => {
  const { t } = useTranslation();
  const [promise, setPromise] = useState<Promise<void> | null>(null);

  return (
    <Modal {...modalProps}>
      <Typography
        sx={{
          py: 2,
        }}
      >
        {t('pleaseChooseLanguage')}
      </Typography>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          flexWrap: 'wrap',
        }}
      >
        {promise ? (
          <Stack
            direction="row"
            sx={{
              justifyContent: 'center',
              alignItems: 'center',
              height: '4rem',
              width: '100%',
            }}
          >
            <CircularProgress />
          </Stack>
        ) : (
          languageChoices.map((lang) => (
            <Button
              key={`language-chooser-modal-${lang.key}`}
              variant="cta"
              onClick={() =>
                setPromise(
                  Promise.resolve(onSelectLanguage(lang.key)).finally(() => {
                    setPromise(null);
                    modalProps.onClose();
                  }),
                )
              }
            >
              {lang.translation}
            </Button>
          ))
        )}
      </Stack>
    </Modal>
  );
};

export default LanguageChooserModal;
